// Common
import { ReactElement, useCallback } from 'react'

// Components
import Row from 'shared-components/row'
import { Button } from '@material-ui/core'

export default function Create(): ReactElement {
	// const token = '5uTSs6kSLFA6SYnBOvEGsJBIcdqW29KT'
	const token = process.env.TOKEN
	const create = useCallback(() => {
		fetch(`${process.env.REACT_APP_API_URL}/questions`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				name: 'Test',
				organization: '604251e0b113097ff44d97ac', // not need to change
				step: 'seven',
				answerOptions: ['test', 'test1', 'test2'],  // the first three values are answer options, (['1980', '2000', '2021', 'age'] the fourth value of array can be 'age' or 'area' or 'quantity' only slider)
				type: 'options', // slider or options
				property: 'appartment', // house or appartment
			}),
		})
	}, [])

	return (
		<Row>
			<Button
				style={{height: '50px', border: '1px solid gray'}}
				onClick={create}
			>
				Create question
			</Button>
		</Row>
	)
}
